import { DEFAULT_THEME, MantineTheme } from '@mantine/core'

const lightTheme: MantineTheme = {
    ...DEFAULT_THEME,
    colorScheme: 'light',
    primaryColor: 'green',
    cursorType: 'pointer',
    fontFamily: `'Inter' , -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif`,
    headings: {
        ...DEFAULT_THEME.headings,
        fontFamily: `'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif`,
    },
}

export { lightTheme }
